import { render, staticRenderFns } from "./PrePrintCard.vue?vue&type=template&id=bc88aa3e&scoped=true"
import script from "./PrePrintCard.vue?vue&type=script&lang=js"
export * from "./PrePrintCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc88aa3e",
  null
  
)

export default component.exports